import StarsRenderer from "../DataGrid/starsRenderer";
import IconRenderer from "../DataGrid/iconRenderer";

// eslint-disable-next-line import/no-anonymous-default-export
export default (props) => {
    return (
        <div className="table-responsive">
            <table id="example2" className="table table-bordered text-nowrap border-bottom table-striped">
                <thead>
                <tr>
                    {
                        props.headers.map(header => <th className="border-bottom-0">{header.name}</th>)
                    }
                </tr>
                </thead>
                <tbody>
                {
                    props.rows.map(row => {
                        return <tr>
                            {
                                row.columns.map((col) => {                                  
                                    if (col.type == 'text') {
                                        return <td>{col.data}</td>
                                    } else if (col.type === 'icon') {
                                        return <td><IconRenderer value={{class: col.data}}/></td>
                                    } else if (col.type === 'ratings') {
                                        return <td><StarsRenderer value={{value: col.data}}/></td>
                                    }
                                })
                            }
                        </tr>
                    })
                }
                </tbody>
            </table>
        </div>
    )
}
